export default __webpack_public_path__ + "static/media/Ardom.5486542d.png";